import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  accept_reject_mentor_hiring_manager_action,
  get_accept_reject_mentor_hiring_manager_action,
} from "../../../redux/_actions";

function useHiringManagerAcceptMentor(props) {
  const [applicationDetails, setApplicationDetails] = useState({});
  const [loadingError, setLoadingError] = useState();
  const [loading, setLoading] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(false);

  const { mentorApplicationData, errorData } = useSelector(
    (state) => state.get_accept_reject_mentor_hiring_manager_reducer
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let url = new URL(window.location.href);
    let applicationId = url.searchParams.get("applicant");
    let jobId = url.searchParams.get("job");
    if (applicationId && jobId) {
      callApi(applicationId);
    } else {
      setLoadingError("Unable to find the application you are looking for.");
    }
  }, []);

  useEffect(() => {
    if (errorData) {
      setLoadingError(errorData);
    }
  }, [errorData]);

  useEffect(() => {
    if (mentorApplicationData?.data) {
      setApplicationDetails(mentorApplicationData?.data);
    }
  }, [mentorApplicationData]);

  useEffect(() => {
    if (mentorApplicationData?.msg) {
      setLoadingError(mentorApplicationData?.msg);
    }
  }, [mentorApplicationData]);

  const callApi = async (applicationId) => {
    setLoading(false);
    await dispatch(
      get_accept_reject_mentor_hiring_manager_action(applicationId)
    );
    setLoading(false);
  };

  const onAcceptRejectClick = async (application_status) => {
    setAcceptLoading(true);
    let data = { application_status: application_status };
    await dispatch(
      accept_reject_mentor_hiring_manager_action(data, applicationDetails?.id)
    );
    setAcceptLoading(false);
  };

  const onViewMentorProfileClick = async (id) => {
    navigate(`/view-mentor-profile/${id}`, {
      state: { id: id },
    });
  };

  return {
    applicationDetails,
    loading,
    loadingError,
    acceptLoading,
    onAcceptRejectClick,
    onViewMentorProfileClick,
  };
}

export default useHiringManagerAcceptMentor;
